/** @jsxImportSource @emotion/react */
import React from 'react';
import PageTemplate from '@page/admin/page-template';
import ClozeHome from '@component/admin/cloze/cloze-home';

const ClozeListPage: React.FC = () => {
  return (
    <PageTemplate title='빈칸문제 관리'>
      <ClozeHome />
    </PageTemplate>
  );
};

export default ClozeListPage;
